import { COLLECTIONS } from "../data/content";
import { Reveal, Tag, ClipReveal, ArrowLink } from "../components/Shared";
import { Link } from "react-router-dom";

const ARCHIVE = [
  { name: "SMARÁ — SS/23", note: "The golden decade, reimagined. Retro and chic, crafted with confidence." },
  { name: "NYFW — SS/19", note: "Fun, flirty, feminine. Delicate florals, bright stripes, breezy dresses." },
  { name: "NYFW — SS/18", note: "The return to the New York runway — sharper, surer." },
  { name: "NYFW — SS/17", note: "The first New York statement from the house." },
];

export default function CollectionsPage() {
  return (
    <div className="bg-ink px-5 pb-32 pt-32 sm:px-10 md:pt-40" data-testid="collections-page">
      <div className="mx-auto max-w-[1600px]">
        <Reveal><Tag>Collections</Tag></Reveal>
        <h1 className="mt-6 font-serif text-6xl font-light tracking-tight sm:text-7xl lg:text-8xl">
          STORIES IN <span className="text-fog">SILHOUETTE.</span>
        </h1>
        <Reveal delay={0.15}>
          <p className="mt-5 max-w-lg text-lg font-light text-fog">
            From New York Fashion Week runways to the current edit — every collection is a chapter.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-x-8 gap-y-16 sm:grid-cols-2 lg:grid-cols-3">
          {COLLECTIONS.map((c, i) => (
            <div key={c.id} className="group" data-testid={`collections-page-card-${c.id}`}>
              <ClipReveal src={c.image} alt={`${c.label} — ${c.caption}`} delay={(i % 3) * 0.1} className="aspect-[3/4]" imgClassName="transition-transform duration-[1.2s] ease-out group-hover:scale-110" />
              <Reveal delay={0.15}>
                <p className="mt-5 font-mono text-[9px] uppercase tracking-[0.35em] text-flame">{String(i + 1).padStart(2, "0")}</p>
                <h2 className="mt-2 font-serif text-3xl font-normal transition-colors duration-300 group-hover:text-flame">{c.label}</h2>
                <p className="mt-1.5 text-sm font-light italic text-fog">{c.caption}</p>
              </Reveal>
            </div>
          ))}
        </div>

        <div className="mt-32 border-t border-line/10 pt-16" data-testid="archive-section">
          <Reveal><Tag>The Archive</Tag></Reveal>
          <div className="mt-8 grid gap-px bg-line/10 md:grid-cols-2 lg:grid-cols-4">
            {ARCHIVE.map((a, i) => (
              <Reveal key={a.name} delay={i * 0.08} className="bg-ink">
                <div className="p-9 transition-colors duration-500 hover:bg-coal" data-testid={`archive-${i}`}>
                  <p className="font-serif text-2xl font-normal text-flame">{a.name}</p>
                  <p className="mt-3 text-sm font-light leading-relaxed text-fog">{a.note}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-12">
            <ArrowLink to="/shop" testId="collections-to-shop-link" big>Shop the Current Edit</ArrowLink>
          </Reveal>
        </div>
      </div>
    </div>
  );
}
